import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'polarity' })
export class PolarityPipe implements PipeTransform {
	public transform(value: string): string {
		const floatVal = Number.parseFloat(value);

		if (floatVal === 0) {
			return value;
		} else if (floatVal > 0) {
			return `+${value}`;
		} else if (floatVal < 0) {
			return value;
		} else {
			return value;
		}
	}
}
